import { useTranslations } from "use-intl";
import { useState } from "react";
import { Check, Flame } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function WarmupStep({ steps, onDone }: { steps: string[]; onDone: () => void }) {
  const t = useTranslations("train");
  const [checked, setChecked] = useState<boolean[]>(() => steps.map(() => false));
  return (
    <div className="pt-6">
      <div className="flex size-14 items-center justify-center rounded-2xl bg-orange-500/15 text-orange-500">
        <Flame className="size-7" />
      </div>
      <h1 className="mt-4 text-3xl font-black tracking-tight">{t("warmupTitle")}</h1>
      <p className="mt-1 text-muted-foreground">{t("warmupIntro")}</p>
      <ol className="mt-6 space-y-2">
        {steps.map((s, i) => (
          <li key={s}>
            <button
              type="button"
              onClick={() => setChecked((c) => c.map((v, j) => (j === i ? !v : v)))}
              className={cn(
                "flex w-full items-start gap-3 rounded-2xl border p-3.5 text-left transition-colors",
                checked[i] && "border-success/40 bg-success/10",
              )}
            >
              <span
                className={cn(
                  "mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-full border-2",
                  checked[i] ? "border-success bg-success text-background" : "border-muted-foreground/40",
                )}
              >
                {checked[i] && <Check className="size-4" strokeWidth={3} />}
              </span>
              <span className="text-sm">{s}</span>
            </button>
          </li>
        ))}
      </ol>
      <Button size="lg" className="mt-6 h-14 w-full rounded-2xl text-base" onClick={onDone}>
        {t("warmupDone")}
      </Button>
    </div>
  );
}
